// src/resources/index.js

// Mevcut fallback (default) logolar - bu dosyalar build ile dahil edilmelidir
const appLoginLogo = require('../static/img/logos/birlesik-logo.png');
const appHeaderLogo = require('../static/img/logos/birlesik-white.png');

// --- default (fallback) logolar ---
const defaultLogin = appLoginLogo;
const defaultHeader = appHeaderLogo;

// --- domain bazlı logo map'i ---
// Buraya yeni domain eklemek için sadece hostname ve dosya require ekle
const DOMAIN_LOGO_MAP = {
  // Birleşik Gümrükleme Logoları
  'bigu.birlesikgumrukleme.com.tr': {
    login: require('../static/img/logos/birlesik-logo.png'),
    header: require('../static/img/logos/birlesik-white.png'),
  },

  //Sun Chemical Logoları
  'www.sctp.com.tr': {
    login: require('../static/img/logos/sctp-logo.png'),
    header: require('../static/img/logos/sctp-white.png'),
  },
  'sctp.com.tr': {
    login: require('../static/img/logos/sctp-logo.png'),
    header: require('../static/img/logos/sctp-white.png'),
  },

  // local geliştirme için örnek
  localhost: {
    login: require('../static/img/logos/birlesik-logo.png'),
    header: require('../static/img/logos/birlesik-white.png'),
  },
  '127.0.0.1': {
    login: require('../static/img/logos/birlesik-logo.png'),
    header: require('../static/img/logos/birlesik-white.png'),
  },
};

// hostname normalizasyon helper
const normalizeHost = host => {
  if (!host) return '';
  const lower = host.toLowerCase();
  // Eğer www.'li ve olmayan versiyonunu aynı saymak istersen şu satırı aç:
  // return lower.replace(/^www\./, '');
  return lower;
};

/**
 * getLogos(hostname?)
 *  - hostname verilmezse window.location.hostname kullanılır (client-side).
 *  - Döndürür: { login, header } (her zaman fallback döndürür).
 */
export function getLogos(providedHostname) {
  const host =
    normalizeHost(
      providedHostname ||
        (typeof window !== 'undefined' ? window.location.hostname : '')
    ) || '';

  // Doğrudan eşleşme
  if (host && DOMAIN_LOGO_MAP[host]) {
    const { login, header } = DOMAIN_LOGO_MAP[host];
    return {
      login: login || defaultLogin,
      header: header || defaultHeader,
    };
  }

  // www. strip edilmiş haliyle kontrol (örn. www.sctp.com.tr -> sctp.com.tr)
  const stripped = host.replace(/^www\./, '');
  if (stripped && DOMAIN_LOGO_MAP[stripped]) {
    const { login, header } = DOMAIN_LOGO_MAP[stripped];
    return {
      login: login || defaultLogin,
      header: header || defaultHeader,
    };
  }

  // Fallback
  return {
    login: defaultLogin,
    header: defaultHeader,
  };
}

// --- images objesini runtime'da dolduruyoruz ---
// Böylece mevcut import kullanımını bozmadan (images['app-header-logo']) domain'e göre değişir.
const resolved = getLogos();
const images = {
  'app-login-logo': resolved.login,
  'app-header-logo': resolved.header,

  // Geri uyumluluk için orijinal fallback isimleri de eklenmiş olabilir
  // (eğer projede başka anahtarlar varsa buraya ekleyebilirsin)
};

// Default export (mevcut kullanım bozulmaz)
export { images };
export default images;
